// ─── Suggestions locales des agents (story 5.5, décision PO Q2) ──────────────
// Pool tournant : repli uniquement (nouvelle conversation, tour sans pills
// backend). Depuis la story 7.3, les pills viennent du backend (`suggestion_pills`).
// Jamais les mêmes 3 pills deux fois de suite.

export const MAX_SUGGESTIONS = 3

export const AGENT_SUGGESTION_POOL: readonly string[] = [
  'Où en sont mes campagnes ?',
  'Quels fournisseurs sont en retard ?',
  'Aide-moi à créer un template',
  'Emmène-moi aux fournisseurs',
  'Que puis-je te demander ?',
  'Ouvre la page des campagnes',
  'Comment relancer un fournisseur ?',
  'Explique-moi le suivi des réponses',
  'Emmène-moi aux paramètres',
]

export function pickSuggestions(
  pool: readonly string[],
  exclude: readonly string[] = [],
  count: number = MAX_SUGGESTIONS,
  random: () => number = Math.random
): string[] {
  const excluded = new Set(exclude)
  let candidates = pool.filter((s) => !excluded.has(s))
  if (candidates.length < count) candidates = [...pool]
  const shuffled = [...candidates]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  return shuffled.slice(0, count)
}

/** Trim, minuscules (fr), accents retirés : clé de dédoublonnage. */
export function normalizeSuggestion(s: string): string {
  return s
    .trim()
    .toLocaleLowerCase('fr')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
}

/** Retire les vides et les doublons (casse / accents), garde la 1re occurrence. */
export function dedupeSuggestions(list: readonly string[]): string[] {
  const seen = new Set<string>()
  const out: string[] = []
  for (const raw of list) {
    const key = normalizeSuggestion(raw)
    if (key === '' || seen.has(key)) continue
    seen.add(key)
    out.push(raw.trim())
  }
  return out
}
